import { AdaptiveModal } from '../common/AdaptiveModal'
import { DialogActivator } from '../common/helpers'

export const CloseModal = ({
  activator,
  onDismiss,
  children,
}: {
  activator: DialogActivator
  onDismiss: () => void
  children?: React.ReactNode
}) => {
  return (
    <AdaptiveModal
      open={activator.open}
      onClose={onDismiss}
      title="Are you sure?"
      secondaryActions={[{ content: 'Return to the wizard', onAction: activator.close }]}
      primaryAction={{
        content: 'Close',
        onAction: onDismiss,
      }}
      sectioned
    >
      {children}
    </AdaptiveModal>
  )
}
